module.exports = __webpack_public_path__ + "media/app-store-detail/Capterra_white-d90281cf.png";